import { tw } from './strings'

export default function DemoNotice({ practice = false }: { practice?: boolean }) {
  return <aside className="warn w-banner" role="note">
    <strong>{tw('w.demo.title')}</strong>{' '}
    {tw(practice ? 'w.demo.practice' : 'w.demo.history')}
  </aside>
}
